import { IconButton, Menu, MenuItem } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import styles from './styles.module.scss';
import React, { useState, FC } from 'react';
import { useTranslation } from 'react-i18next';

export type MenuOptionCallBack = Maybe<() => void>;

export interface OverflowMenuOption {
  optionClickCallBack: MenuOptionCallBack;
  key: string;
  renderItem: () => React.ReactNode | string;
}

interface ComponentProps {
  options: OverflowMenuOption[];
  itemHeight?: number;
  onOpen?: () => void;
}

const ITEM_HEIGHT = 48;

export const OverFlowMenu: FC<ComponentProps> = ({ options, itemHeight , onOpen}): JSX.Element => {
  const height = itemHeight || ITEM_HEIGHT;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    onOpen?.();
  };
  const handleClose = (ev: React.MouseEvent<HTMLLIElement, MouseEvent>, reason: 'backdropClick' | 'escapeKeyDown' | undefined, cb?: MenuOptionCallBack) => {
    cb?.();
    setAnchorEl(null);
  };
  const { t } = useTranslation();

  return (
    <div className={styles.overFlowMenu} data-testid='overflow-menu-button'>
      <IconButton
        id='overFlowMenu'
        aria-label={t('aria.more_actions')}
        className={styles.icon}
        aria-controls='long-menu'
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup='true'
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        data-testid='overflow-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: height * 4.5,
            width: '20ch',
          },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.key} onClick={(ev) => {
            handleClose(ev, undefined, option.optionClickCallBack);
          }}>
            {option.renderItem()}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};
